module.exports = __webpack_public_path__ + "img/weixin.e549e2af.png";